import React from "react";
import "./App.css";
// import Band from "./band/band";
import Band from "./main/band";

function App() {
  return <Band />;
}

export default App;
